function arrayToIdxObject(arr: (number | string)[], keyName?: string) {
  const obj: { [key: string]: number | string } = {};
  arr.forEach((item, index) => {
    obj[`${keyName || 'idx'}[${index}]`] = item;
  });
  return obj;
}

export default arrayToIdxObject;
